// EVE Online planetary resource availability per planet type.
// Source: https://wiki.eveuniversity.org/Planetary_Industry#Planet_types
// Used to drive the survey UI: each planet only allows P0 yields for the
// resources its type can extract.

export type PlanetType =
  | "Barren"
  | "Gas"
  | "Ice"
  | "Lava"
  | "Oceanic"
  | "Plasma"
  | "Storm"
  | "Temperate";

export const PLANET_TYPES: PlanetType[] = [
  "Barren",
  "Gas",
  "Ice",
  "Lava",
  "Oceanic",
  "Plasma",
  "Storm",
  "Temperate",
];

// Game rule: only Barren and Temperate can build P4 Advanced Industry Facilities.
export const P4_ELIGIBLE_PLANET_TYPES: ReadonlySet<PlanetType> = new Set([
  "Barren",
  "Temperate",
]);

export const P0_BY_PLANET_TYPE: Record<PlanetType, readonly string[]> = {
  Barren: [
    "Aqueous Liquids",
    "Base Metals",
    "Carbon Compounds",
    "Microorganisms",
    "Noble Metals",
  ],
  Gas: [
    "Aqueous Liquids",
    "Base Metals",
    "Ionic Solutions",
    "Noble Gas",
    "Reactive Gas",
  ],
  Ice: [
    "Aqueous Liquids",
    "Heavy Metals",
    "Microorganisms",
    "Noble Gas",
    "Planktic Colonies",
  ],
  Lava: [
    "Base Metals",
    "Felsic Magma",
    "Heavy Metals",
    "Non-CS Crystals",
    "Suspended Plasma",
  ],
  Oceanic: [
    "Aqueous Liquids",
    "Carbon Compounds",
    "Complex Organisms",
    "Microorganisms",
    "Planktic Colonies",
  ],
  Plasma: [
    "Base Metals",
    "Heavy Metals",
    "Noble Metals",
    "Non-CS Crystals",
    "Suspended Plasma",
  ],
  Storm: [
    "Aqueous Liquids",
    "Base Metals",
    "Ionic Solutions",
    "Noble Gas",
    "Suspended Plasma",
  ],
  Temperate: [
    "Aqueous Liquids",
    "Autotrophs",
    "Carbon Compounds",
    "Complex Organisms",
    "Microorganisms",
  ],
};
